import Importacao from '../../spa/importacao/Importacao';

export default {
  path: 'importacoes',
  name: 'importacoes',
  component: Importacao,
};
